import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { activeOrganization$ } from "~/stores/organizations";

/**
 * Parent route for the post-catalog board picker step. Owns the shared
 * `beforeLoad` gate so both the param child (`$datasourceId`) and the
 * resume fallback (`index`) inherit it.
 *
 * Accepts `"contact"` and `"boards"` so navigations from `/onboard/contact`
 * after Continue aren't bounced during the brief window before
 * `setOrgOnboardingStep("boards")` resolves. The boards step is pre-payment
 * — users pick their board suggestions before being asked to pay; a
 * background supervisor chat thread per pick generates the dashboards while
 * they finish Stripe Checkout.
 */
export const Route = createFileRoute("/onboard/boards")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (org.onboarding !== "contact" && org.onboarding !== "boards") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: () => <Outlet />,
});
